export default {
  agentInviteData: "",
  recentlyViewedOpportunities: [],
  recentlyViewedBrokerages: [],
  recentlyViewedAgents: [],
  recentlyViewedMyAgents: [],
};
